import React, { useEffect, useState } from 'react'
import { Button, Col, FormGroup, Row } from 'reactstrap'
import Custom from 'components/custom/Index';
import filterIcon from 'assets/icon/filters-icon.svg'
import useContextService from 'hooks/useContextService';
import exports from 'assets/icon/export-icon.svg';

const Filters = (props) => {
  const { filterslist, onHandelFilterChange, onSearch, filters, resetFilter,
    filtershow, setFilterShow, setStartPage, selectedValues, totalRecords,
    setSelectedValues, ceid, exportDisabled = false } = props
  let countryList = [
    { id: 1, name: "12 - Column" },
    { id: 2, name: "6 - Column" },
  ]

  const [openDropdown, setOpenDropdown] = useState(null);
  const [filter, setFilters] = useState({});

  const handelFilterClick = () => {
    setFilterShow(!filtershow)
    setOpenDropdown(false)
    if (filtershow) {
      setSelectedValues(filterslist.map((item) => item.filterdataFiled));
      if (ceid) {
        onSearch({}, filtershow);
        setStartPage(2)
      } 
    }
    else {
      setFilters((prevFilters) => ({
        ...prevFilters,
        frequency: '',
        claimType: ''
      }));
    }
    //setStartPage(2)
    // filters.currentPage= 1
  }

  useEffect(() => {
    if (resetFilter) {
      setSelectedValues({
        claimTypeDesc: '',
        frequencyDesc: '',
      });
      setOpenDropdown(null);
    }
  }, [resetFilter]);

  const handleDropdownToggle = (dropdownId) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdownId);
    }
  };

  const handleValueSelect = (filterName, selectedValue) => {
    setSelectedValues((prev) => {
      let newSelectedValues = { ...prev, [filterName]: selectedValue };
      return newSelectedValues;

    });
  };

  return (
    <div>
      <Row className='py-3'>
        <div className="col-auto" style={{ borderRight: "1px solid #DDDDDD", paddingRight: "1rem", }}>

          <Button
            color="primary"
            disabled={ceid == undefined || ceid == '' || ceid.length == 0 || ceid == null }
            className="filter"
            onClick={handelFilterClick}
          >
            <span className='right_5'> <img src={filterIcon} alt="" /></span>
            Filters
          </Button>
        </div>
        {filtershow == true ?
          <Col className="p-0">
            <div className='d-flex justify-content-start'>
              {filterslist.map((item, index) => {
                return (
                  <div className='table-dropdown' style={{ display: "inline-flex" }}>
                    <FormGroup className='controls ms-3 mb-0'>
                      <Custom
                        //defaultText={item.filterName}
                        defaultText={selectedValues[item.filterdataFiled] || item.filterName}
                        item={item}
                        onSearch={onSearch}
                        filters={filters}
                        onHandelFilterChange={onHandelFilterChange}
                        filtershow={filtershow}
                        setStartPage={setStartPage}
                        openDropdown={openDropdown}
                        handleDropdownToggle={handleDropdownToggle}
                        handleValueSelect={handleValueSelect}
                        filter={filter}
                        setFilters={setFilters}
                        ceid={ceid}
                      //setHasFilter={setHasFilter}
                      //hasfilter={hasfilter}
                      // onHandelFilterChange={onHandelFilterChange}
                      // configurationsTable={configurationsTable}
                      />
                    </FormGroup>
                  </div>
                )
              })}
            </div>
          </Col>
          : <Col>
          </Col>}
        <div className="col-auto">
          <Button
            // hidden={isAddPermission}
            color="primary"
            className="btn-export"
            onClick={""}
            disabled={exportDisabled}
          // hidden={!hasPermission("ADD")}
          >
            <span className='right_5'> <img src={exports} alt="" /></span>
            Export
          </Button>
        </div>
      </Row>
    </div>
  )
}

export default Filters